import { TypographyH2 } from '@talentmesh/ui/components/typography';
import UIStrings from '@/Utils/UIStrings';

const JobAdStepHeader = () => {
    return (
        <div className="flex flex-col items-center justify-center gap-2 py-2.5">
            <TypographyH2 className="text-foreground">{UIStrings.CreateJobDescription}</TypographyH2>
        </div>
    );
};

export default JobAdStepHeader;
